import { useScreen } from "@/hooks/useScreen";
import type { IApiCollection } from "@/types/api";
import type React from "react";

interface CollectionBannerProps {
  collection: IApiCollection;
  className?: string;
}

interface BannerImage {
  url: string;
  altText: string;
}

const CollectionBanner: React.FC<CollectionBannerProps> = ({
  collection,
  className = "",
}) => {
  const { isMobile } = useScreen();

  const getBannerImage = (): BannerImage | null => {
    const metafields = (collection as any)?.metafields;

    const findBanner = (key: string): BannerImage | null => {
      const field = metafields?.find(
        (f: any) => f?.key === key && f?.reference?.image?.url,
      );
      return field
        ? {
            url: field.reference.image.url,
            altText: field.reference.image.altText,
          }
        : null;
    };

    if (Array.isArray(metafields)) {
      if (isMobile) {
        return findBanner("mobile_image");
      }
      return findBanner("desktop_image");
    }

    return null;
  };

  const bannerImage = getBannerImage();
  if (!bannerImage) return null;

  return (
    <div className={`w-full ${className}`}>
      <img
        src={bannerImage.url}
        alt={bannerImage.altText}
        className="w-full h-auto object-cover"
        loading="eager"
      />
    </div>
  );
};

export default CollectionBanner;
